// extracted by mini-css-extract-plugin
export var aside = "aside-module--aside--6eb48";